// Deep links to the organizer Oireachtas panel (/organizer-oireachtas/:id) and
// its stage schedule (/organizer-oireachtas/:id/schedule, card 524449bc).
// A logged-out visit (bookmark, shared link, expired session) goes to the
// organizer login and comes back to the panel afterwards. Only a panel path is
// ever remembered or honoured, so the stored value can't become an open
// redirect to another page or site.
const KEY = 'organizerReturnPath';
// also /pair: a phone that scanned a device's QR code signs in, then comes
// back to pick the event (its code waits in sessionStorage, device/PairScan)
const PANEL_PATH = /^(\/organizer-oireachtas\/[A-Za-z0-9]+(\/schedule)?|\/pair)\/?$/;

export const isOrganizerPanelPath = (pathname) => PANEL_PATH.test(String(pathname || ''));

export function rememberOrganizerReturnPath(pathname) {
  if (!isOrganizerPanelPath(pathname)) return;
  try {
    sessionStorage.setItem(KEY, pathname);
  } catch (e) {
    /* storage unavailable: the organizer just lands on the dashboard */
  }
}

// Read once and clear; returns null unless it is a panel path.
export function takeOrganizerReturnPath() {
  let path = null;
  try {
    path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
  } catch (e) {
    return null;
  }
  return isOrganizerPanelPath(path) ? path : null;
}

// The API answers an ended session (expired/invalid token, user gone) with 401
// or a 403 whose message says so; "not your event" is a different 403 and must
// NOT loop the organizer back through login.
const SESSION_ENDED = /session expired|invalid token|error finding user/i;
export function sessionEndedOnPanel(status, message, pathname) {
  if (!isOrganizerPanelPath(pathname)) return false;
  if (status === 401) return true;
  return status === 403 && SESSION_ENDED.test(String(message || ''));
}
